export default __webpack_public_path__ + "static/media/gozdem8.a12d25eb.jpg";